/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ring_TomorrowInputs */

const en_ring_tomorrow = /** @type {(inputs: Ring_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow`)
};

/**
* | output |
* | --- |
* | "Tomorrow" |
*
* @param {Ring_TomorrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const ring_tomorrow = /** @type {((inputs?: Ring_TomorrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ring_TomorrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_ring_tomorrow(inputs)
});